import React from "react";
import ExpenseItemGenericSkeleton from "./ExpenseItemGenericSkeleton";

function ExpenseItemDetailSkeleton() {
  return (
    <>
      <ExpenseItemGenericSkeleton />
    </>
  );
}

export default ExpenseItemDetailSkeleton;
